import styled, { css } from "styled-components";

export const Container = styled.button<{ isActive?: boolean }>`
  position: relative;
  display: flex;
  gap: var(--fd-space-space-2);
  align-items: center;
  padding: var(--fd-space-space-2) var(--fd-space-space-4);
  border-bottom: 1px solid ${({ theme }) => theme.colorTokens.border.default};
  height: 45px;
  background-color: ${({ theme }) => theme.colorTokens.background.surface};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colorTokens.background.hover};
  }

  ${({ isActive }) =>
    isActive &&
    css`
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 3px;
        z-index: 1;
        background-color: var(--fd-colors-border-active);
      }
    `}
`;

export const SecondSectionWrapper = styled.div`
  display: flex;
  gap: var(--fd-space-space-2);
  justify-content: flex-end;
  align-items: center;
  margin-left: auto;
`;

export const TagsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TagContainer = styled.div<{
  zIndex: number;
}>`
  display: inline-flex;
  border-radius: 99px;
  border: 2px solid ${({ theme }) => theme.colorTokens.border.inverse};
  z-index: ${({ zIndex }) => zIndex};

  &:not(:first-child) {
    margin-left: -6px;
  }
`;

export const IconWrapper = styled.div`
  margin-right: var(--fd-space-space-2);
`;

export const MtpContainer = styled.div`
  flex-shrink: 0;
`;
